var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4686 11.7104C65.4686 7.04917 61.6907 3.27124 57.0295 3.27124H27.804C23.1428 3.27124 19.3643 7.04917 19.3643 11.7104V75.0137C19.3643 79.6749 23.1428 83.4528 27.804 83.4528H57.0295C61.6907 83.4528 65.4686 79.6749 65.4686 75.0137V11.7104ZM23.3733 17.9044H61.4596V64.6101H23.3733V17.9044ZM27.7633 7.28032H57.0703C59.5127 7.28032 61.4596 9.31618 61.4596 11.7592V13.8953H23.3733V11.7592C23.3733 9.31618 25.3209 7.28032 27.7633 7.28032ZM57.0703 79.4437H27.7633C25.3553 79.4613 23.3902 77.5219 23.3733 75.1139V68.6192H61.4596V75.0626C61.4715 77.4705 59.5296 79.4318 57.1216 79.4437H57.0703Z",
    fill: "#3D3D3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3387 72.0264H38.4928C37.3853 72.0264 36.4883 72.9234 36.4883 74.0309C36.4883 75.1384 37.3853 76.0354 38.4928 76.0354H46.3387C47.4456 76.0354 48.3433 75.1384 48.3433 74.0309C48.3433 72.9234 47.4456 72.0264 46.3387 72.0264Z",
    fill: "#3D3D3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.8f0fda3301105705bda40375f0a5406d.svg";
export { ForwardRef as ReactComponent };